import { render, staticRenderFns } from "./comp_AppBar-TopMsg.vue?vue&type=template&id=040e4fe3&scoped=true"
import script from "./comp_AppBar-TopMsg.vue?vue&type=script&lang=js"
export * from "./comp_AppBar-TopMsg.vue?vue&type=script&lang=js"
import style0 from "./comp_AppBar-TopMsg.vue?vue&type=style&index=0&id=040e4fe3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040e4fe3",
  null
  
)

export default component.exports